import { fetchRing } from '../core';
import { sourceRefId } from '../../lib/funnel';

export const ENTITY_RISK_SCORES_RING = 'entity_risk_scores';

export interface EntityRiskDriver {
  contribution?: number | string;
  evidence_ids?: string[];
  label?: string;
  term?: string;
}

export interface EntityRiskEvolution {
  at?: string;
  delta?: number | string | null;
  score?: number | string;
  top_driver?: string;
}

export interface EntityRiskAttackingAction {
  action_id?: string;
  actor_class?: string;
  campaign_id?: string | null;
  name?: string;
  success?: boolean;
}

export interface EntityRiskScoreDocument {
  _id?: string;
  element_id?: string | { value?: string };
  element_name?: string;
  score?: number | string;
  band?: string;
  model?: string;
  breakdown?: Record<string, number | string>;
  weights?: Record<string, number | string>;
  top_drivers?: EntityRiskDriver[];
  evolution?: EntityRiskEvolution[];
  attacking_actions?: EntityRiskAttackingAction[];
  attacking_campaigns?: string[];
  previous_score?: number | string | null;
  score_delta_7d?: number | string | null;
  computed_at?: string;
  run_id?: string;
  origin?: string;
  [key: string]: unknown;
}

export function entityRiskElementId(row: Pick<EntityRiskScoreDocument, 'element_id'>): string {
  return sourceRefId(row.element_id);
}

export function ringItems<T>(res: { items?: T[]; data?: unknown; documents?: unknown } | T[]): T[] {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res.items)) return res.items;
  if (Array.isArray(res.data)) return res.data as T[];
  if (Array.isArray(res.documents)) return res.documents as T[];
  return [];
}

export async function getEntityRiskScoresAll(): Promise<EntityRiskScoreDocument[]> {
  const res = await fetchRing<EntityRiskScoreDocument>(ENTITY_RISK_SCORES_RING, { all: true });
  return ringItems<EntityRiskScoreDocument>(res);
}
